import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
// import CssBaseline from '@mui/material/CssBaseline';
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  Divider,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { handleKeyPressFolderPath } from "../../../utils/validationFunctions";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { useFormContext } from "react-hook-form";

function ProjectInformation({
  // currentStep,
  handleChange,
  area,
  height,
  buildingType,
  changeRate,
  dropSupply,
  flowSupply,
  flowReturn,
  dropReturn,
  projName,
  setAirFlowCalc,
  airFlowCalc,
  isEditing,
  airFlowCalculatorFields,
  airFlowDirectInputFields,
  calculateAirFlow,
  active1,
  areMandatoryStepFieldsFilled,
  projectItem,
  snackbarDispatch,
  setSnackbar,
}) {
  const {
    register,
    handleSubmit,
    control,
    trigger,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  // const [input, setInput] = useState(false);
  const [area1, setArea] = useState(false);
  const [height1, setHeight] = useState(false);
  const [changeRate1, setChangeRate] = useState(false);
  const [dropSupply1, setDropSupply] = useState(false);
  const [flowSupply1, setFlowSupply] = useState(false);
  const [flowReturn1, setFlowReturn] = useState(false);
  const [dropReturn1, setDropReturn] = useState(false);
  const isFirstRender = useRef(true);
  const [directAirflowSupply, setDirectAirflowSupply] = useState(1120);
  const [directAirflowReturn, setDirectAirflowReturn] = useState(1120);
  const [calculatorArea, setCalculatorArea] = useState(100);
  const [calculatorHeight, setCalculatorHeight] = useState(2.8);
  const [calculatorBuildingType, setCalculatorBuildingType] = useState(
    "Residential - Basements (3-4)"
  );
  const [calculatorChangeRate, setCalculatorChangeRate] = useState(4);
  const { t } = useTranslation();
  const theme = useTheme();

  // const onUnmount = React.useRef();
  // onUnmount.current = () => {
  //   if (active1) {
  //     calculateAirFlow();
  //   }
  // };
  // useEffect(() => {
  //   return () => onUnmount.current();
  // }, []);

  const validationProjInfo = () => {
    if (
      // Project information
      projectItem.projName !== "" &&
      projectItem.area !== "" &&
      projectItem.height !== "" &&
      projectItem.buildingType !== "" &&
      projectItem.changeRate !== "" &&
      projectItem.dropSupply !== "" &&
      projectItem.flowSupply !== "" &&
      projectItem.flowReturn !== "" &&
      projectItem.dropReturn !== ""
    ) {
      if (
        projectItem.flowSupply < 600 ||
        projectItem.flowSupply > 6800 ||
        projectItem.flowReturn < 600 ||
        projectItem.flowReturn > 6800
      ) {
        snackbarDispatch(setSnackbar(true, "error", t("snackbar.invalidFlow")));
        return false;
      } else return true;
    } else {
      snackbarDispatch(
        setSnackbar(true, "error", t("snackbar.mandatoryFields"))
      );

      return false;
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    } else {
      let timeOut = setTimeout(() => {
        if (validationProjInfo()) {
          calculateAirFlow();
        }
      }, 3000);

      return () => {
        clearTimeout(timeOut);
      };
    }
  }, [flowSupply, flowReturn]);

  useEffect(() => {
    /*if (isFirstRender.current) {
      isFirstRender.current = false;*/
    //if (isEditing) {

    if (
      airFlowCalc &&
      (directAirflowReturn !== flowReturn || directAirflowSupply !== flowSupply)
    ) {
      if (isFirstRender.current) isFirstRender.current = false;

      setDirectAirflowSupply(flowSupply);
      setDirectAirflowReturn(flowReturn);
      setCalculatorArea(+area);
      setCalculatorHeight(+height);
      setCalculatorBuildingType(buildingType);
      setCalculatorChangeRate(+changeRate);
      // }
      //}
    }
    if (!airFlowCalc && isEditing) {
      if (isFirstRender.current) isFirstRender.current = false;
      setCalculatorArea(+area);
      setCalculatorHeight(+height);
      setCalculatorBuildingType(buildingType);
      setCalculatorChangeRate(+changeRate);
      // }
      //}
    }
    window.scrollTo(0, 0);
  }, [
    airFlowCalc,
    flowSupply,
    flowReturn,
    area,
    height,
    buildingType,
    changeRate,
  ]);

  // useEffect(() => {
  //   console.log("test test");
  //   return () => {
  //     console.log("test test test");
  //     if (active1) return calculateAirFlow();
  //   };
  // }, []);

  const validate = () => {
    if (area.length !== "") {
      setArea(false);
    } else {
      setArea(true);
    }

    if (height.length !== "") {
      setHeight(false);
    } else {
      setHeight(true);
    }

    if (changeRate.length !== "") {
      setChangeRate(false);
    } else {
      setChangeRate(true);
    }

    if (dropSupply.length !== "") {
      setDropSupply(false);
    } else {
      setDropSupply(true);
    }

    if (flowSupply.length !== "") {
      setFlowSupply(false);
    } else {
      setFlowSupply(true);
    }

    if (flowReturn.length !== "") {
      setFlowReturn(false);
    } else {
      setFlowReturn(true);
    }

    if (dropReturn.length !== "") {
      setDropReturn(false);
    } else {
      setDropReturn(true);
    }
  };

  // if (currentStep !== 1) return null;

  const handleChangeSwitch = (e) => {
    // setInput(!input);
    setAirFlowCalc(!airFlowCalc);
    airFlowCalc
      ? airFlowCalculatorFields(
          calculatorArea,
          calculatorHeight,
          calculatorBuildingType,
          calculatorChangeRate
        )
      : airFlowDirectInputFields(+directAirflowSupply, +directAirflowReturn);
  };

  // const Calculation = () => {
  //   flowSupply = area * height * changeRate;
  //   flowReturn = area * height * changeRate;
  // };
  const building = [
    {
      value: "Residential - Basements (3-4)",
      label: t("buildingTypes.Residential - Basements (3-4)"),
    },
    {
      value: "Residential - Badrooms (5-6)",
      label: t("buildingTypes.Residential - Badrooms (5-6)"),
    },
    {
      value: "Residential - Bathrooms (6-7)",
      label: t("buildingTypes.Residential - Bathrooms (6-7)"),
    },
    {
      value: "Residential - Family Living Rooms (6-8)",
      label: t("buildingTypes.Residential - Family Living Rooms (6-8)"),
    },
    {
      value: "Residential - Kitchens (7-8)",
      label: t("buildingTypes.Residential - Kitchens (7-8)"),
    },
    {
      value: "Residential - Laudry (8-9)",
      label: t("buildingTypes.Residential - Laudry (8-9)"),
    },
    {
      value: "Light Commercial - Offices - Business Offices (6-8)",
      label: t(
        "buildingTypes.Light Commercial - Offices - Business Offices (6-8)"
      ),
    },
    {
      value: "Light Commercial - Offices - Lunch Break Rooms (7-8)",
      label: t(
        "buildingTypes.Light Commercial - Offices - Lunch Break Rooms (7-8)"
      ),
    },
    {
      value: "Light Commercial - Offices - Conference Rooms (8-12)",
      label: t(
        "buildingTypes.Light Commercial - Offices - Conference Rooms (8-12)"
      ),
    },
    {
      value: "Light Commercial - Offices - Medical Procedure Offices (9-10)",
      label: t(
        "buildingTypes.Light Commercial - Offices - Medical Procedure Offices (9-10)"
      ),
    },
    {
      value: "Light Commercial - Offices - Copy Rooms (10-12)",
      label: t("buildingTypes.Light Commercial - Offices - Copy Rooms (10-12)"),
    },
    {
      value: "Light Commercial - Offices - Main Computer Rooms (10-14)",
      label: t(
        "buildingTypes.Light Commercial - Offices - Main Computer Rooms (10-14)"
      ),
    },
    {
      value: "Light Commercial - Offices - Smoking Area (13-15)",
      label: t(
        "buildingTypes.Light Commercial - Offices - Smoking Area (13-15)"
      ),
    },
    {
      value: "Light Commercial - Restaurants - Dining Area (8-10)",
      label: t(
        "buildingTypes.Light Commercial - Restaurants - Dining Area (8-10)"
      ),
    },
    {
      value: "Light Commercial - Restaurants - Food Staging (10-12)",
      label: t(
        "buildingTypes.Light Commercial - Restaurants - Food Staging (10-12)"
      ),
    },
    {
      value: "Light Commercial - Restaurants - Kitchens (14-18)",
      label: t(
        "buildingTypes.Light Commercial - Restaurants - Kitchens (14-18)"
      ),
    },
    {
      value: "Light Commercial - Restaurants - Bars (15-20)",
      label: t("buildingTypes.Light Commercial - Restaurants - Bars (15-20)"),
    },
    {
      value: "Light Commercial - Public Buildings - Hallways (6-8)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Hallways (6-8)"
      ),
    },
    {
      value: "Light Commercial - Public Buildings - Retail Stores (6-10)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Retail Stores (6-10)"
      ),
    },
    {
      value: "Light Commercial - Public Buildings - Foyers (8-10)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Foyers (8-10)"
      ),
    },
    {
      value: "Light Commercial - Public Buildings - Churches (8-12)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Churches (8-12)"
      ),
    },
    {
      value: "Light Commercial - Public Buildings - Restrooms (10-12)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Restrooms (10-12)"
      ),
    },
    {
      value: "Light Commercial - Public Buildings - Auditoriums (12-14)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Auditoriums (12-14)"
      ),
    },
    {
      value: "Light Commercial - Public Buildings - Smoking Rooms (15-20)",
      label: t(
        "buildingTypes.Light Commercial - Public Buildings - Smoking Rooms (15-20)"
      ),
    },
    {
      value: "None",
      label: t("buildingTypes.None"),
    },
  ];

  return (
    <Container component="main" sx={{ mb: 4, "min-width": "100%" }}>
      <Paper
        variant="outlined"
        sx={{
          // my: { xs: 3, md: 6 },
          // mx: { xs: 3, md: 6 },
          marginTop: "0px",
          p: { xs: 2, md: 3 },
          align: "center",
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          <Box
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            {" "}
            <Typography
              sx={{ textAlign: "center", fontSize: "38px", mb: "20px" }}
            >
              {t("mainform.info")}
            </Typography>
          </Box>

          <TextField
            name="projName"
            label={t("projectinformation.name")}
            fullWidth
            type="text"
            InputLabelProps={{ shrink: true }}
            // Use react-hook-form for value and onChange
            {...register("projName", { required: true })}
            error={Boolean(errors.projName)}
            helperText={errors.projName && t("projectinformation.nameRequired")}
            onKeyPress={handleKeyPressFolderPath}
            required
          />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              margin: "20px 0",
            }}
          >
            <Typography
              variant="body1"
              textAlign="center"
              sx={{
                color: theme.palette.primary.main,
                // mt: 1,
                fontSize: { xs: "14px", sm: "16px" },
                cursor: "pointer",
              }}
            >
              {t("projectinformation.item1")}
            </Typography>{" "}
            <FormControlLabel
              control={
                <Switch
                  onChange={handleChangeSwitch}
                  name="input1"
                  checked={airFlowCalc}
                  sx={{ ml: 2, color: theme.palette.primary.main }}
                />
              }
              // label={t("projectinformation.item2")}
              sx={{ mb: 0 }}
            />
            <Typography
              variant="body1"
              textAlign="center"
              sx={{
                color: theme.palette.primary.main,
                // mt: 1,
                fontSize: { xs: "14px", sm: "16px" },
                cursor: "pointer",
              }}
            >
              {t("projectinformation.item2")}
            </Typography>{" "}
          </Box>
        </Box>
        {/* Group A: Air flow fields - Always in upper section, always selectable */}
        <Box
          component="form"
          sx={{ "& .MuiTextField-root": { width: "41%" } }}
          noValidate
          autoComplete="off"
        >
          <Box>
            <TextField
              fullWidth
              id="flowSupply"
              label={t("projectinformation.flowsupplay")}
              name="flowSupply"
              autoComplete={t("projectinformation.flowsupplay")}
              value={airFlowCalc ? directAirflowSupply : flowSupply}
              onChange={(e) => {
                setDirectAirflowSupply(e.target.value);
                handleChange(e);
              }}
              onBlur={validate}
              type="number"
              InputLabelProps={{ shrink: true }}
              helperText={flowSupply1 ? `${t("projectinformation.err")}` : ""}
              error={flowSupply1}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">m³/h</InputAdornment>
                ),
                onWheel: (e) => e.target.blur(),
              }}
            />
            <TextField
              fullWidth
              id="dropSupply"
              label={t("projectinformation.dropsupplay")}
              name="dropSupply"
              autoComplete={t("projectinformation.dropsupplay")}
              value={dropSupply}
              onChange={handleChange}
              onBlur={validate}
              type="number"
              InputLabelProps={{ shrink: true }}
              helperText={dropSupply1 ? `${t("projectinformation.err")}` : ""}
              error={dropSupply1}
              sx={{ float: "right" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">Pa</InputAdornment>
                ),
                onWheel: (e) => e.target.blur(),
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: { sm: 2 },
            }}
          >
            <TextField
              fullWidth
              id="flowReturn"
              label={t("projectinformation.flowreturn")}
              name="flowReturn"
              autoComplete={t("projectinformation.flowreturn")}
              value={airFlowCalc ? directAirflowReturn : flowReturn}
              onChange={(e) => {
                setDirectAirflowReturn(e.target.value);
                handleChange(e);
              }}
              onBlur={validate}
              type="number"
              InputLabelProps={{ shrink: true }}
              helperText={flowReturn1 ? `${t("projectinformation.err")}` : ""}
              error={flowReturn1}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">m³/h</InputAdornment>
                ),
                onWheel: (e) => e.target.blur(),
              }}
            />
            <TextField
              fullWidth
              id="dropReturn"
              label={t("projectinformation.dropreturn")}
              name="dropReturn"
              autoComplete={t("projectinformation.dropreturn")}
              value={dropReturn}
              onChange={handleChange}
              onBlur={validate}
              type="number"
              InputLabelProps={{ shrink: true }}
              helperText={dropReturn1 ? `${t("projectinformation.err")}` : ""}
              error={dropReturn1}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">Pa</InputAdornment>
                ),
                onWheel: (e) => e.target.blur(),
              }}
            />
          </Box>
        </Box>
        {/* Group B: Area/Height/Building Type/Change Rate - In lower section, optionally selectable */}
        {!airFlowCalc && (
          <>
            <Box sx={{ m: 1 }}>
              <Divider sx={{ mb: 3, mt: 3 }} />
            </Box>
            <Box>
              <Box
                component="form"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  "& .MuiTextField-root": { m: 1, width: "41%" },
                  marginBottom: "20px",
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  margin="normal"
                  fullWidth
                  id="area"
                  label={t("projectinformation.area")}
                  name="area"
                  autoComplete={t("projectinformation.area")}
                  value={calculatorArea}
                  onChange={(e) => {
                    setCalculatorArea(+e.target.value);
                    handleChange(e);
                  }}
                  onBlur={validate}
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  helperText={area1 ? `${t("projectinformation.err")}` : ""}
                  error={area1}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">m²</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="height"
                  label={t("projectinformation.height")}
                  name="height"
                  autoComplete={t("projectinformation.height")}
                  value={calculatorHeight}
                  onChange={(e) => {
                    setCalculatorHeight(+e.target.value);
                    handleChange(e);
                  }}
                  onBlur={validate}
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  helperText={height1 ? `${t("projectinformation.err")}` : ""}
                  error={height1}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">m</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "41%" },
                  display: "flex",
                  justifyContent: "space-between",
                }}
                noValidate
                autoComplete="off"
              >
                <FormControl sx={{ ml: 1, width: "41%" }}>
                  <InputLabel
                    id="select-label"
                    sx={{ mb: 1, color: "#373437" }}
                  >
                    {t("projectinformation.buildingType")}
                  </InputLabel>
                  <Select
                    disablePortal
                    sx={{
                      mb: 1,
                      width: "100%",
                    }}
                    MenuProps={{ disableScrollLock: true }}
                    labelId="select-label"
                    value={calculatorBuildingType}
                    name="buildingType"
                    label={t("projectinformation.buildingType")}
                    onChange={(e) => {
                      setCalculatorBuildingType(e.target.value);
                      let airChangeValue;
                      if (e.target.value === "None") airChangeValue = 0;
                      else
                        airChangeValue = e.target.value.substring(
                          e.target.value.lastIndexOf("-") + 1,
                          e.target.value.lastIndexOf(")")
                        );
                      setCalculatorChangeRate(airChangeValue);
                      handleChange(e);
                    }}
                    defaultValue={"Residential - Basements (3-4)"}
                  >
                    {building.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  margin="normal"
                  fullWidth
                  id="changeRate"
                  label={t("projectinformation.changerate")}
                  name="changeRate"
                  autoComplete={t("projectinformation.changerate")}
                  value={calculatorChangeRate}
                  onChange={(e) => {
                    setCalculatorChangeRate(+e.target.value);
                    handleChange(e);
                  }}
                  onBlur={validate}
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    changeRate1 ? `${t("projectinformation.err")}` : ""
                  }
                  InputProps={{
                    onWheel: (e) => e.target.blur(),
                  }}
                  error={changeRate1}
                />
              </Box>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
}

export default ProjectInformation;
